module.exports = __webpack_public_path__ + "static/media/clock.fed6c8a7.svg";